import React from 'react';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';
import { TrendingItemsSkinnable } from './TrendingItemsSkinnable';
import { TrendingItemsComponentProps } from './TrendingItems.types';
import { adaptTrendingItemsProps } from './TrendingItems.adapter';
import { COMPONENT_TYPES } from '../../../constants';

/**
 * 트렌딩 아이템 컴포넌트
 * 스킨 시스템을 사용하여 UI를 렌더링합니다.
 */
const TrendingItemsComponent: React.FC<TrendingItemsComponentProps> = (props) => {

  
  // 어댑터를 통해 props 변환
  const adaptedProps = adaptTrendingItemsProps(props);
  
  // ComponentData 구성
  const componentData = {
    id: adaptedProps.id || `${COMPONENT_TYPES.TRENDING_ITEMS || 'TRENDING_ITEMS'}-${Date.now()}`,
    type: COMPONENT_TYPES.TRENDING_ITEMS || 'TRENDING_ITEMS',
    componentProps: adaptedProps.componentProps || {},
    props: adaptedProps,
    theme: adaptedProps.theme || {},
    externalSkin: adaptedProps.externalSkin,
    style: adaptedProps.style,
    className: adaptedProps.className
  };
  
  // 렌더 모드 결정
  const mode = adaptedProps.isEditor ? 'editor' : 
               adaptedProps.isPreview ? 'preview' : 'production';
  
  // 에디터 props (필요한 경우)
  const editorProps = adaptedProps.isEditor ? {
    isSelected: adaptedProps.isSelected || false,
    onSelect: adaptedProps.onSelect || (() => {}),
    onEdit: adaptedProps.onEdit || (() => {}),
    onDelete: adaptedProps.onDelete || (() => {}),
    dragHandleProps: adaptedProps.dragHandleProps
  } : undefined;
  
  return (
    <ComponentSkinWrapper
      component={TrendingItemsSkinnable}
      componentData={componentData}
      mode={mode}
      editorProps={editorProps}
    />
  );
};

export default TrendingItemsComponent;